<template>
  <div class="maincont child" id="acount_mod">
    <div class="ef--inner2">

      <div class="page-title">
        <h2 v-if="editMode == 'new'">アカウント追加</h2>
        <h2 v-if="editMode != 'new'">アカウント編集</h2>
      </div>

      <div class="form" method="post" action>

        <div id="page_info" class="page-info page-info-color">
          <div class="setting-info">
            <!--***********************************************************---
            <--- 基本情報
            <---***********************************************************-->
            <div class="block-info">

              <details open>
                <summary class="summary-info">基本情報</summary>

                <div class="display-flex">
                  <div class="block-info" style="border-right: 1px solid #d3d3d3;">
                    <!--=====================================================---
                    <--- アカウント
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.account">アカウント</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="normal"
                            id="base_info.account"
                            name="base_info.account"
                            v-model="param.base_info.account"
                            v-validate="'max:16|required|alpha_num'"
                            data-vv-as="アカウント"
                            v-if="editMode == 'new'"
                          />
                          <input
                            type="text"
                            class="normal"
                            id="base_info.account"
                            v-model="param.base_info.account"
                            readonly
                            style="border:none;"
                            v-else
                          />
                          <div class="err-message" v-if="errors.has('base_info.account')">{{ errors.first("base_info.account") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- パスワード
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info" v-if="editMode == 'new'">
                        <label class="title" for="base_info.password">パスワード</label>
                        <div class="body display-inline">
                          <input
                            type="password"
                            class="normal"
                            id="base_info.password"
                            name="base_info.password"
                            v-model="param.base_info.password"
                            v-validate="{
                              required: true,
                              regex: /^[0-9a-zA-Z!&quot;#$%&amp;@'|<>(){}\[\]*+,./_\-~=\;\:\?\^]{6,16}$/
                            }"
                            data-vv-as="パスワード"
                          />
                          <div class="err-message" v-show="errors.has('base_info.password')">
                            パスワードは大文字、小文字、数値、
                            <br />
                            記号 (`~!@#$%^&*()_+-={}|[]:";'&lt;>?,./)
                            <br />
                            で6～16文字で入力してください。
                          </div>
                        </div>
                      </div>

                      <div class="item-info" v-else>
                        <label class="title" for="base_info.password">パスワード</label>
                        <div class="body display-inline">
                          <input
                            type="button"
                            class="small"
                            id="base_info.password"
                            value="パスワード変更"
                            @click="showModal = true"
                            v-if="this.$store.state.loginType != 3"
                          />
                          <input
                            v-else
                          />
                        </div>
                      </div>
                    </div>

                  <div class="line-info">
                    <!--=====================================================---
                    <--- お客さま名
                    <---=====================================================-->
                    <div class="item-info">
                      <label class="title" for="base_info.company_name">お客さま名</label>
                      <div class="body display-inline">
                        <input
                          type="text"
                          class="max"
                          id="base_info.company_name"
                          name="base_info.company_name"
                          v-model="param.base_info.company_name"
                          v-validate="'max:30|required'"
                          data-vv-as="お客さま名"
                        />
                        <div class="err-message" v-if="errors.has('base_info.company_name')">{{ errors.first("base_info.company_name") }}</div>
                      </div>
                    </div>
                  </div>

                    <!--=====================================================---
                    <--- 代表メールアドレス
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.representative_mail_address">代表メールアドレス</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="max"
                            id="base_info.representative_mail_address"
                            name="base_info.representative_mail_address"
                            v-model="param.base_info.representative_mail_address"
                            v-validate="'email|max:32'"
                            data-vv-as="代表メールアドレス"
                          />
                          <div class="err-message" v-if="errors.has('base_info.representative_mail_address')">{{ errors.first("base_info.representative_mail_address") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 支店・営業所
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------
                      <--- 支店
                      <-------------------------------->
                      <div class="item-info">
                        <label class="title" for="base_info.sales_center_id">支店</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="param.base_info.sales_center_id"
                          >
                            <option
                              v-for="(option, index) in $store.state.salesCenterMaster"
                              v-bind:value="option.sales_center_id"
                              v-bind:key="index"
                              >{{ option.sales_center_name }}</option
                            >
                          </select>
                        </div>
                      </div>

                      <!--------------------------------
                      <--- 営業所
                      <-------------------------------->
                      <div class="item-info">
                        <label class="title" for="base_info.sales_office_id">営業所</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="param.base_info.sales_office_id"
                          >
                            <option value=""></option>
                            <option
                              v-for="(option, index) in filterSalesOffice"
                              v-bind:value="option.sales_office_id"
                              v-bind:key="index"
                              >{{ option.sales_office_name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 気象実況地域
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------------
                      <--- 気象実況地域
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="base_info.lclid">気象実況地域</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="prefCode"
                          >
                            <option
                              v-for="(option, index) in prefOptions"
                              v-bind:value="option.prefecture_code"
                              v-bind:key="index"
                              >{{ option.name }}</option
                            >
                          </select>
                        </div>
                      </div>

                      <!--------------------------------------
                      <--- 実況地点
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="base_info.amsid">実況地点</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="amsid"
                          >
                            <option
                              v-for="(option, index) in fillerdWeatherArea"
                              v-bind:value="option.amsid"
                              v-bind:key="index"
                              >{{ option.area_name }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="block-info" style="border-left: 1px solid #d3d3d3;">
                    <!--=====================================================---
                    <--- アカウント種別
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.account_type">アカウント種別</label>
                        <div class="body display-flex">
                          <input
                            type="radio"
                            id="base_info.account_type.parent"
                            value="20"
                            v-model="param.base_info.account_type"
                          />
                          <label for="base_info.account_type.parent">グループ</label>

                          <input
                            type="radio"
                            id="base_info.account_type.child"
                            value="10"
                            v-model="param.base_info.account_type"
                          />
                          <label for="base_info.account_type.child">シングル</label>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 需給状況管理
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.supply_management">需給状況管理</label>
                        <div class="body display-flex">
                          <input
                            type="radio"
                            id="base_info.supply_management.false"
                            value="false"
                            v-model="param.base_info.supply_management"
                            v-bind:disabled="param.base_info.account_type != 20"
                            v-bind:style="param.base_info.account_type != 20 ? 'background-color: lightgray' : ''"
                          />
                          <label for="base_info.supply_management.false">無</label>

                          <input
                            type="radio"
                            id="base_info.supply_management.true"
                            value="true"
                            v-model="param.base_info.supply_management"
                            v-bind:disabled="param.base_info.account_type != 20"
                            v-bind:style="param.base_info.account_type != 20 ? 'background-color: lightgray' : ''"
                          />
                          <label for="base_info.supply_management.true">有</label>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- グループアカウント
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.parent_account">グループアカウント</label>
                        <div class="body display-inline">
                          <select
                            class="max" 
                            v-model="param.base_info.parent_account"
                            v-bind:disabled="param.base_info.account_type == 20"
                            v-bind:style="param.base_info.account_type == 20 ? 'background-color: lightgray' : ''"
                          >
                            <option value=""></option>
                            <option
                              v-for="(option, index) in parentList"
                              v-bind:value="option.account"
                              v-bind:key="index"
                              >{{ option.name }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 使用機能
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.function_type">使用機能</label>
                        <div class="body display-flex">
                          <input
                            type="radio"
                            id="base_info.function_type.power"
                            value="1"
                            v-model="param.base_info.function_type"
                            v-bind:disabled="param.base_info.account_type == 20"
                            v-bind:style="param.base_info.account_type == 20 ? 'background-color: lightgray' : ''"
                          />
                          <label for="base_info.function_type.power">電力見える化</label>

                          <input
                            type="radio"
                            id="base_info.function_type.es"
                            value="2"
                            v-model="param.base_info.function_type"
                            v-bind:disabled="param.base_info.account_type == 20"
                            v-bind:style="param.base_info.account_type == 20 ? 'background-color: lightgray' : ''"
                          />
                          <label for="base_info.function_type.es">ES</label>
                        </div>
                      </div>
                    </div>

                    <br />
                    <br />

                    <!--=====================================================---
                    <--- アカウント状態
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="base_info.deleted_flg">アカウント状態</label>
                        <div class="body display-flex">
                          <input
                            type="checkbox"
                            id="base_info.deleted_flg"
                            name="base_info.deleted_flg"
                            v-model="param.deleted_flg"
                          />
                          <label style="color:#f00" for="base_info.deleted_flg" class="checkbox">削除</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </details>
            </div>

            <!--***********************************************************---
            <--- 電力見える化情報
            <---***********************************************************-->
            <div class="block-info">
              <details open>
                <summary class="summary-info">電力見える化情報</summary>
                <div class="display-flex">
                  <div class="block-info" style="border-right: 1px solid #d3d3d3;">
                    <!--=====================================================---
                    <--- デマンド目標値・でんき予報補正係数
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------------
                      <--- デマンド目標値
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.contract_power">デマンド目標値</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.contract_power"
                            name="power_info.contract_power"
                            v-model="param.power_info.contract_power"
                            v-validate="'required|numeric|max:4'"
                            data-vv-as="デマンド目標値"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <label class="supply">kW</label>
                          <div class="err-message" v-if="errors.has('power_info.contract_power')">{{ errors.first("power_info.contract_power") }}</div>
                        </div>
                      </div>

                      <!--------------------------------------
                      <--- でんき予報補正係数
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.intercept_correction">でんき予報補正係数</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.intercept_correction"
                            name="power_info.intercept_correction"
                            v-model="param.power_info.intercept_correction"
                            v-validate="'min_value:0|max_value:100|required|numeric'"
                            data-vv-as="でんき予報補正係数"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <label class="supply">％</label>
                          <div class="err-message" v-if="errors.has('power_info.intercept_correction')">{{ errors.first("power_info.intercept_correction") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 観測機種別・観測機ID
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------------
                      <--- 観測機種別
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.measure_instrument">観測機種別</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="param.power_info.measure_instrument"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          >
                            <option
                              v-for="(option, index) in observationMachineTypes"
                              v-bind:value="option.machine_code"
                              v-bind:key="index"
                              >{{ option.name }}</option>
                          </select>
                        </div>
                      </div>

                      <!--------------------------------------
                      <--- 観測機ID
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.observation_machine_serial_no">観測機ID</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.observation_machine_serial_no"
                            name="power_info.observation_machine_serial_no"
                            v-model="param.power_info.observation_machine_serial_no"
                            v-validate="param.power_info.measure_instrument == 2 ? 'required|min:10|max:16|alpha_num' : 'required|max:8|alpha_num'"
                            data-vv-as="対象機器の観測機ID"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <div class="err-message" v-if="errors.has('power_info.observation_machine_serial_no')">{{ errors.first("power_info.observation_machine_serial_no") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- パルス係数
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.pulse_counting">パルス係数</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.pulse_counting"
                            name="power_info.pulse_counting"
                            list="pulse_list"
                            v-model="param.power_info.pulse_counting"
                            v-validate="'min_value:0.0001|max_value:9999.9999'"
                            data-vv-as="パルス係数"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument != 2"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument != 2 ? 'background-color: lightgray' : ''"
                          />
                          <datalist id="pulse_list">
                            <option
                              v-for="(option, index) in pulseCoefficient"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument != 2"
                            >{{ option.text }}</option>
                          </datalist>
                          <div class="err-message" v-if="errors.has('power_info.pulse_counting')">{{ errors.first("power_info.pulse_counting") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- デマンドディレイ
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------------
                      <--- デマンドディレイ
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.delay_time">デマンドディレイ</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.delay_time"
                            name="power_info.delay_time"
                            v-model="param.power_info.delay_time"
                            v-validate="'required|numeric|min_value:0|max_value:30'"
                            data-vv-as="デマンドディレイ"
                            v-bind:disabled="editMode == 'new' || param.base_info.function_type != 1 || param.power_info.measure_instrument != 2"
                            v-bind:style="editMode == 'new' || param.base_info.function_type != 1 || param.power_info.measure_instrument != 2 ? 'background-color: lightgray' : ''"
                          />
                          <div class="err-message" v-if="errors.has('power_info.delay_time')">{{ errors.first("power_info.delay_time") }}</div>
                        </div>
                      </div>

                      <!--------------------------------------
                      <--- 基準時間
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.base_time">基準時間</label>
                        <div class="body display-inline">
                          <select
                            class="small"
                            v-model="param.power_info.base_time"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument != 2"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument != 2 ? 'background-color: lightgray' : ''"
                          >
                            <option
                              v-for="(option, index) in referenceTime"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 空調機制御
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="status">空調機制御</label>
                        <div class="body display-flex">
                          <input
                            type="radio"
                            id="power_info.air_conditioner_control.false"
                            value="false"
                            v-model="param.power_info.air_conditioner_control"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 ? 'background-color: lightgray' : ''"
                          />
                          <label for="power_info.air_conditioner_control.false">無</label>

                          <input
                            type="radio"
                            id="power_info.air_conditioner_control.true"
                            value="true"
                            v-model="param.power_info.air_conditioner_control"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 ? 'background-color: lightgray' : ''"
                          />
                          <label for="power_info.air_conditioner_control.true">有</label>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 注意電力・限界電力
                    <---=====================================================-->
                    <div class="line-info">
                      <!--------------------------------------
                      <--- 注意電力
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.caution_power">注意電力</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.caution_power"
                            name="power_info.caution_power"
                            v-model="param.power_info.caution_power"
                            v-validate="(param.power_info.air_conditioner_control == 'true' ? 'required|':'')+'numeric|min_value:0|max_value:9999'"
                            data-vv-as="注意電力"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true'"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true' ? 'background-color: lightgray' : ''"
                          />
                          <label class="supply">kW</label>
                          <div class="err-message" v-if="errors.has('power_info.caution_power')">{{ errors.first("power_info.caution_power") }}</div>
                        </div>
                      </div>

                      <!--------------------------------------
                      <--- 限界電力
                      <-------------------------------------->
                      <div class="item-info">
                        <label class="title" for="power_info.limit_power">限界電力</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.limit_power"
                            name="power_info.limit_power"
                            v-model="param.power_info.limit_power"
                            v-validate="(param.power_info.air_conditioner_control == 'true' ? 'required|':'')+'numeric|min_value:1|max_value:9999|comp_limit_power:'+param.power_info.caution_power"
                            data-vv-as="限界電力"
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true'"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true' ? 'background-color: lightgray' : ''"
                          />
                          <label class="supply">kW</label>
                          <div class="err-message" v-if="errors.has('power_info.limit_power')">{{ errors.first("power_info.limit_power") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 余裕率
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.margin">余裕率</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="small"
                            id="power_info.margin"
                            name="power_info.margin"
                            v-model="param.power_info.margin"
                            v-validate="(param.power_info.air_conditioner_control == 'true' ? 'required|':'')+'numeric|min_value:1|max_value:99'"
                            data-vv-as="余裕率" 
                            v-bind:disabled="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true'"
                            v-bind:style="param.base_info.function_type != 1 || param.power_info.measure_instrument == 1 || param.power_info.air_conditioner_control != 'true' ? 'background-color: lightgray' : ''"
                          />
                          <label class="supply">％</label>
                          <div class="err-message" v-if="errors.has('power_info.margin')">{{ errors.first("power_info.margin") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 月別閾値設定
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="detail_setting">月別閾値</label>
                        <div class="body display-inline">
                          <input
                            type="button"
                            class="small"
                            id="setting_demand"
                            value="月別閾値設定"
                            v-bind:disabled="editMode == 'new' || param.base_info.function_type != 1"
                            v-bind:style="editMode == 'new' || param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                            @click="$router.push(`/admin/setting_demand/${param.base_info.account}`)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="block-info" style="border-left: 1px solid #d3d3d3;">
                    <!--=====================================================---
                    <--- 支店情報
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.sales">支店情報</label>
                        <div class="body display-inline">
                          <table class="list-table">
                            <thead>
                              <tr>
                                <th style="width:20px;">No</th>
                                <th style="width:430px;">配信アドレス</th>
                                <th style="width:80px;">デマンド通知</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-----------------------------------------------------------------
                              <-- 配信アドレス１
                              <----------------------------------------------------------------->
                              <tr>
                                <td>1</td>
                                <td>
                                  <input
                                    type="text"
                                    class="max"
                                    id="power_info.sales_mail_address_1"
                                    name="power_info.sales_mail_address_1"
                                    v-model="param.power_info.sales_mail_address_1"
                                    v-validate="`email|max:64`"
                                    data-vv-as="配信アドレス"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('power_info.sales_mail_address_1')">{{ errors.first("power_info.sales_mail_address_1") }}</div>
                                </td>
                                <td>
                                  <select
                                    class="max"
                                    v-model="param.power_info.sales_alert_send_flg_1"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in salesAlertOptions"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}</option
                                    >
                                  </select>
                                </td>
                              </tr>

                              <!-----------------------------------------------------------------
                              <-- 配信アドレス２
                              <----------------------------------------------------------------->
                              <tr>
                                <td>2</td>
                                <td>
                                  <input
                                    type="text"
                                    class="max"
                                    id="power_info.sales_mail_address_2"
                                    name="power_info.sales_mail_address_2"
                                    v-model="param.power_info.sales_mail_address_2"
                                    v-validate="`email|max:64`"
                                    data-vv-as="配信アドレス"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('power_info.sales_mail_address_2')">{{ errors.first("power_info.sales_mail_address_2") }}</div>
                                </td>
                                <td>
                                  <select
                                    class="max"
                                    v-model="param.power_info.sales_alert_send_flg_2"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in salesAlertOptions"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}</option
                                    >
                                  </select>
                                </td>
                              </tr>

                              <!-----------------------------------------------------------------
                              <-- 配信アドレス３
                              <----------------------------------------------------------------->
                              <tr>
                                <td>3</td>
                                <td>
                                  <input
                                    type="text"
                                    class="max"
                                    id="power_info.sales_mail_address_3"
                                    name="power_info.sales_mail_address_3"
                                    v-model="param.power_info.sales_mail_address_3"
                                    v-validate="`email|max:64`"
                                    data-vv-as="配信アドレス"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('power_info.sales_mail_address_3')">{{ errors.first("power_info.sales_mail_address_3") }}</div>
                                </td>
                                <td>
                                  <select
                                    class="max"
                                    v-model="param.power_info.sales_alert_send_flg_3"
                                    v-bind:disabled="param.base_info.function_type != 1"
                                    v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in salesAlertOptions"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}</option
                                    >
                                  </select>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- アラート通知先アドレス
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.alert_destination_mail_address">アラート通知先<br/>アドレス</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="max"
                            id="power_info.alert_destination_mail_address"
                            name="power_info.alert_destination_mail_address"
                            v-model="param.power_info.alert_destination_mail_address"
                            v-validate="`email|max:32`"
                            data-vv-as="アラートコール送信先アドレス"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <div class="err-message" v-if="errors.has('power_info.alert_destination_mail_address')">{{ errors.first("power_info.alert_destination_mail_address") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- 便利ツール
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.general_tool_url">便利ツール</label>
                        <div class="body display-inline">
                          <input
                            type="text"
                            class="max"
                            id="power_info.general_tool_url"
                            name="power_info.general_tool_url"
                            value
                            placeholder="https://"
                            v-model="param.power_info.general_tool_url"
                            v-validate="{ url: { require_protocol: true }, max: 128 }"
                            data-vv-as="便利ツール"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <div class="err-message" v-if="errors.has('power_info.general_tool_url')">{{ errors.first("power_info.general_tool_url") }}</div>
                        </div>
                      </div>
                    </div>

                    <!--=====================================================---
                    <--- メモ
                    <---=====================================================-->
                    <div class="line-info">
                      <div class="item-info">
                        <label class="title" for="power_info.memo">メモ</label>
                        <div class="body display-inline">
                          <textarea
                            class="max"
                            id="power_info.memo"
                            name="power_info.memo"
                            v-model="param.power_info.memo"
                            v-validate="'max:512'"
                            data-vv-as="メモ"
                            v-bind:disabled="param.base_info.function_type != 1"
                            v-bind:style="param.base_info.function_type != 1 ? 'background-color: lightgray' : ''"
                          />
                          <div class="err-message" v-if="errors.has('power_info.memo')">{{ errors.first("power_info.memo") }}</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </details>
            </div>

            <!--***********************************************************---
            <--- ES情報
            <---***********************************************************-->
            <div class="block-info">
              <details open>
                <summary class="summary-info">ES情報</summary>
                <div class="display-block">
                  <div class="display-flex">
                    <div class="block-info" style="border-right: 1px solid #d3d3d3;">
                      <!--=====================================================---
                      <--- サービス期間開始
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.service_start">サービス期間開始</label>
                          <div class="body display-flex">
                            <input
                              type="date"
                              class="small"
                              id="es_info.service_start"
                              name="es_info.service_start"
                              v-model="param.es_info.service_start"
                              data-vv-as="サービス期間開始"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <label class="supply">{{ getServicePeriod(param.es_info.service_start) }}</label>
                          </div>
                        </div>
                      </div>

                      <!--=====================================================---
                      <--- サービス期間終了
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.service_end">サービス期間終了</label>
                          <div class="body display-flex">
                            <input
                              type="date"
                              class="small"
                              id="es_info.service_end"
                              name="es_info.service_end"
                              v-model="param.es_info.service_end"
                              data-vv-as="サービス期間終了"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                          </div>
                        </div>
                      </div>

                      <!--=====================================================---
                      <--- お客さま所在地
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.address">お客さま所在地</label>
                          <div class="body display-flex">
                            <input
                              type="text"
                              class="max"
                              id="es_info.address"
                              name="es_info.address"
                              v-model="param.es_info.address"
                              v-validate="'max:128'"
                              data-vv-as="お客さま所在地"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <div class="err-message" v-if="errors.has('es_info.address')">{{ errors.first("es_info.address") }}</div>
                          </div>
                        </div>
                      </div>

                      <!--=====================================================---
                      <--- クラスタID・エリア名称
                      <---=====================================================-->
                      <div class="line-info">
                        <!--------------------------------
                        <--- クラスタID
                        <-------------------------------->
                        <div class="item-info">
                          <label class="title" for="es_info.cluster_id">クラスタID</label>
                          <div class="body display-inline">
                            <select
                              class="small"
                              v-model="param.es_info.cluster_id"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            >
                              <option value=""></option>
                              <option
                                v-for="(option, index) in clusterInfo"
                                v-bind:value="option.cluster_id"
                                v-bind:key="index"
                                >{{ option.cluster_id }}</option
                              >
                            </select>
                          </div>
                        </div>

                        <!--------------------------------
                        <--- エリア名称
                        <-------------------------------->
                        <div class="item-info">
                          <label class="title" for="es_info.area_id">エリア名称</label>
                          <div class="body display-inline">
                            <select
                              class="max"
                              v-model="param.es_info.area_id"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            >
                              <option value=""></option>
                              <option
                                v-for="(option, index) in areaInfo"
                                v-bind:value="option.area_id"
                                v-bind:key="index"
                                >{{ option.area }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <!--=====================================================---
                      <--- 設備設定
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.device">設備設定</label>
                          <div class="body display-flex">
                            <!--------------------------------------
                            <--- 空調
                            <-------------------------------------->
                            <input
                              type="checkbox"
                              id="es_info.device.aircon"
                              name="es_info.device.aircon"
                              v-model="es_device.aircon.bool"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <label for="es_info.device.aircon">空調</label>

                            <!--------------------------------------
                            <--- 受変電
                            <-------------------------------------->
                            <input
                              type="checkbox"
                              id="es_info.device.receiver"
                              name="es_info.device.receiver"
                              v-model="es_device.receiver.bool"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <label for="es_info.device.receiver">受変電</label>

                            <!--------------------------------------
                            <--- 発電
                            <-------------------------------------->
                            <input
                              type="checkbox"
                              id="es_info.device.generator"
                              name="es_info.device.generator"
                              v-model="es_device.generator.bool"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <label for="es_info.device.generator">発電</label>
                          </div>
                        </div>
                      </div>

                      <!--=====================================================---
                      <--- 項目設定
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.item_setting">項目設定</label>
                          <div class="body display-flex">
                            <!--------------------------------------
                            <--- 監視項目設定
                            <-------------------------------------->
                            <input
                              type="button"
                              class="small"
                              id="es_info.item_setting"
                              value="項目設定"
                              v-bind:disabled="editMode == 'new' || param.base_info.function_type != 2"
                              v-bind:style="editMode == 'new' || param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                              @click=""
                              @click="$router.push(`/admin/item_setting/${param.base_info.account}`)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="block-info" style="border-left: 1px solid #d3d3d3;">
                      <!--=====================================================---
                      <--- メモ
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.memo">メモ</label>
                          <div class="body display-flex">
                            <textarea
                              class="max"
                              id="es_info.memo"
                              name="es_info.memo"
                              v-model="param.es_info.memo"
                              v-validate="'max:512'"
                              data-vv-as="メモ"
                              v-bind:disabled="param.base_info.function_type != 2"
                              v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                            />
                            <div class="err-message" v-if="errors.has('es_info.memo')">{{ errors.first("es_info.memo") }}</div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="display-block">
                  <div class="display-flex">
                    <div class="block-info" style="border-right: 1px solid #d3d3d3;">
                      <!--=====================================================---
                      <--- お客さま窓口
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.customer_info">お客さま窓口</label>
                          <div class="body display-inline">
                            <input
                              type="button"
                              class="mini"
                              id="es_info.customer_info.add"
                              value="追 加"
                              @click="addCustomer()"
                              v-bind:disabled="param.base_info.function_type != 2 || param.es_info.customer_info.length >= 20"
                              v-bind:style="param.base_info.function_type != 2 || param.es_info.customer_info.length >= 20 ? 'background-color: lightgray' : ''"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="line-info" v-for="(item, index) in param.es_info.customer_info" v-bind:key="index">
                        <div class="item-info">
                          <label class="title" for="es_info.customer_info.no">お客さま窓口 {{ index + 1 }}</label>
                          <div class="body display-block">
                            <table class="list-table">
                              <!--------------------------------------
                              <--- 氏名
                              <-------------------------------------->
                              <tr>
                                <th style="width:30%;" colspan="2">氏名</th>
                                <td style="width:70%;">
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.customer_info.name.'+index"
                                    v-model="item.name"
                                    v-validate="'max:32'"
                                    data-vv-as="氏名"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.name.'+index)">{{ errors.first("es_info.customer_info.name."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 電話番号
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">電話番号</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.customer_info.telephone.'+index"
                                    v-model="item.telephone"
                                    v-validate="{
                                      max: 16,
                                      regex: /^[0-9][0-9-]*[0-9]$/
                                    }"
                                    data-vv-as="電話番号"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.telephone.'+index)">{{ errors.first("es_info.customer_info.telephone."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 部門
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">部門</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.customer_info.department.'+index"
                                    v-model="item.department"
                                    v-validate="'max:32'"
                                    data-vv-as="部門"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.department.'+index)">{{ errors.first("es_info.customer_info.department."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 担当
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">担当</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.customer_info.charge.'+index"
                                    v-model="item.charge"
                                    v-validate="'max:32'"
                                    data-vv-as="担当"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.charge.'+index)">{{ errors.first("es_info.customer_info.charge."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- メールアドレス
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">メールアドレス</th>
                                <td>
                                  <input
                                    type="text"
                                    class="max"
                                    :name="'es_info.customer_info.mail_address.'+index"
                                    v-model="item.mail_address"
                                    v-validate="'email|max:64'"
                                    data-vv-as="メールアドレス"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.mail_address.'+index)">{{ errors.first("es_info.customer_info.mail_address."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 2値(軽故障)
                              <-------------------------------------->
                              <tr>
                                <th rowspan="4">通知設定</th>
                                <th>2値(軽故障)</th>
                                <td>
                                  <select
                                    class="mini"
                                    :name="'es_info.customer_info.binary_minor_start.'+index"
                                    v-model="item.binary_minor_start"
                                    v-validate="item.binary_minor_end == null ? '' : 'required'"
                                    data-vv-as="開始時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <label> ～ </label>
                                  <select
                                    class="mini"
                                    :name="'es_info.customer_info.binary_minor_end.'+index"
                                    v-model="item.binary_minor_end"
                                    v-validate="item.binary_minor_start == null ? '' : 'required|comp_end_time:'+item.binary_minor_start"
                                    data-vv-as="終了時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.binary_minor_start.'+index)">{{ errors.first("es_info.customer_info.binary_minor_start."+index) }}</div>
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.binary_minor_end.'+index)">{{ errors.first("es_info.customer_info.binary_minor_end."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 2値(重故障)
                              <-------------------------------------->
                              <tr>
                                <th>2値(重故障)</th>
                                <td>
                                  <select
                                    class="mini"
                                    :name="'es_info.customer_info.binary_major_start.'+index"
                                    v-model="item.binary_major_start"
                                    v-validate="item.binary_major_end == null ? '' : 'required'"
                                    data-vv-as="開始時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <label> ～ </label>
                                  <select
                                    class="mini"
                                    :name="'es_info.customer_info.binary_major_end.'+index"
                                    v-model="item.binary_major_end"
                                    v-validate="item.binary_major_start == null ? '' : 'required|comp_end_time:'+item.binary_major_start"
                                    data-vv-as="終了時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.binary_major_start.'+index)">{{ errors.first("es_info.customer_info.binary_major_start."+index) }}</div>
                                  <div class="err-message" v-if="errors.has('es_info.customer_info.binary_major_end.'+index)">{{ errors.first("es_info.customer_info.binary_major_end."+index) }}</div>
                                </td>
                              </tr>
                            </table>

                            <div class="line-info">
                              <input
                                type="button"
                                class="small"
                                :name="'es_info.customer_info.test_mail.'+index"
                                value="テストメール送信"
                                @click="sendTestMail(item, 'es_info.customer_info.mail_address.'+index)"
                                v-bind:disabled="param.base_info.function_type != 2"
                                v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                              />

                              <div class="tips">
                                <p>通知設定</p>
                                <ul>
                                  <li>
                                    通知をメール配信する時間帯を入力します。<br />
                                    設定時間帯以外は、メール通知を保留し、設定時間になったら配信します。
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="block-info" style="border-left: 1px solid #d3d3d3;">
                      <!--=====================================================---
                      <--- 当社担当
                      <---=====================================================-->
                      <div class="line-info">
                        <div class="item-info">
                          <label class="title" for="es_info.supplier_info">当社担当</label>
                          <div class="body display-inline">
                            <input
                              type="button"
                              class="mini"
                              id="es_info.supplier_info.add"
                              value="追 加"
                              @click="addSupplier()"
                              v-bind:disabled="param.base_info.function_type != 2 || param.es_info.supplier_info.length >= 20"
                              v-bind:style="param.base_info.function_type != 2 || param.es_info.supplier_info.length >= 20 ? 'background-color: lightgray' : ''"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="line-info" v-for="(item, index) in param.es_info.supplier_info" v-bind:key="index">
                        <div class="item-info">
                          <label class="title" for="es_info.supplier_info.no">当社担当 {{ index + 1 }}</label>
                          <div class="body display-block">
                            <table class="list-table">
                              <!--------------------------------------
                              <--- 氏名
                              <-------------------------------------->
                              <tr>
                                <th style="width:30%;" colspan="2">氏名</th>
                                <td style="width:70%;">
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.supplier_info.name.'+index"
                                    v-model="item.name"
                                    v-validate="'max:32'"
                                    data-vv-as="氏名"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.name.'+index)">{{ errors.first("es_info.supplier_info.name."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 電話番号
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">電話番号</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.supplier_info.telephone.'+index"
                                    v-model="item.telephone"
                                    v-validate="{
                                      max: 16,
                                      regex: /^[0-9][0-9-]*[0-9]$/
                                    }"
                                    data-vv-as="電話番号"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.telephone.'+index)">{{ errors.first("es_info.supplier_info.telephone."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 部門
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">部門</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.supplier_info.department.'+index"
                                    v-model="item.department"
                                    v-validate="'max:32'"
                                    data-vv-as="部門"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.department.'+index)">{{ errors.first("es_info.supplier_info.department."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 担当
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">担当</th>
                                <td>
                                  <input
                                    type="text"
                                    class="normal"
                                    :name="'es_info.supplier_info.charge.'+index"
                                    v-model="item.charge"
                                    v-validate="'max:32'"
                                    data-vv-as="担当"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.charge.'+index)">{{ errors.first("es_info.supplier_info.charge."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- メールアドレス
                              <-------------------------------------->
                              <tr>
                                <th colspan="2">メールアドレス</th>
                                <td>
                                  <input
                                    type="text"
                                    class="max"
                                    :name="'es_info.supplier_info.mail_address.'+index"
                                    v-model="item.mail_address"
                                    v-validate="'email|max:64'"
                                    data-vv-as="メールアドレス"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  />
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.mail_address.'+index)">{{ errors.first("es_info.supplier_info.mail_address."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 2値(軽故障)
                              <-------------------------------------->
                              <tr>
                                <th rowspan="4">通知設定</th>
                                <th>2値(軽故障)</th>
                                <td>
                                  <select
                                    class="mini"
                                    :name="'es_info.supplier_info.binary_minor_start.'+index"
                                    v-model="item.binary_minor_start"
                                    v-validate="item.binary_minor_end == null ? '' : 'required'"
                                    data-vv-as="開始時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <label> ～ </label>
                                  <select
                                    class="mini"
                                    :name="'es_info.supplier_info.binary_minor_end.'+index"
                                    v-model="item.binary_minor_end"
                                    v-validate="item.binary_minor_start == null ? '' : 'required|comp_end_time:'+item.binary_minor_start"
                                    data-vv-as="終了時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.binary_minor_start.'+index)">{{ errors.first("es_info.supplier_info.binary_minor_start."+index) }}</div>
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.binary_minor_end.'+index)">{{ errors.first("es_info.supplier_info.binary_minor_end."+index) }}</div>
                                </td>
                              </tr>

                              <!--------------------------------------
                              <--- 2値(重故障)
                              <-------------------------------------->
                              <tr>
                                <th>2値(重故障)</th>
                                <td>
                                  <select
                                    class="mini"
                                    :name="'es_info.supplier_info.binary_major_start.'+index"
                                    v-model="item.binary_major_start"
                                    v-validate="item.binary_major_end == null ? '' : 'required'"
                                    data-vv-as="開始時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <label> ～ </label>
                                  <select
                                    class="mini"
                                    :name="'es_info.supplier_info.binary_major_end.'+index"
                                    v-model="item.binary_major_end"
                                    v-validate="item.binary_major_start == null ? '' : 'required|comp_end_time:'+item.binary_major_start"
                                    data-vv-as="終了時間"
                                    v-bind:disabled="param.base_info.function_type != 2"
                                    v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                                  >
                                    <option
                                      v-for="(option, index) in notifyTime"
                                      v-bind:value="option.value"
                                      v-bind:key="index"
                                      >{{ option.text }}
                                    </option>
                                  </select>
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.binary_major_start.'+index)">{{ errors.first("es_info.supplier_info.binary_major_start."+index) }}</div>
                                  <div class="err-message" v-if="errors.has('es_info.supplier_info.binary_major_end.'+index)">{{ errors.first("es_info.supplier_info.binary_major_end."+index) }}</div>
                                </td>
                              </tr>
                            </table>

                            <div class="line-info">
                              <input
                                type="button"
                                class="small"
                                :name="'es_info.supplier_info.test_mail_'+index"
                                value="テストメール送信"
                                @click="sendTestMail(item, 'es_info.supplier_info.mail_address.'+index)"
                                v-bind:disabled="param.base_info.function_type != 2"
                                v-bind:style="param.base_info.function_type != 2 ? 'background-color: lightgray' : ''"
                              />

                              <div class="tips">
                                <p>通知設定</p>
                                <ul>
                                  <li>
                                    通知をメール配信する時間帯を入力します。<br />
                                    設定時間帯以外は、メール通知を保留し、設定時間になったら配信します。
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </details>
            </div>

            <!--***********************************************************---
            <--- ボタン
            <---***********************************************************-->
            <div class="block-info display-center">
              <input
                type="button"
                id="submit"
                class="submit"
                value="登　録"
                @click="onUpdateAccount"
                v-if="this.$store.state.loginType != 3"
              />
              <input
                type="button"
                id="cancel"
                class="cancel"
                value="キャンセル"
                @click="$router.go(-1)"
              />
            </div>

          </div>
        </div>
      </div>
    </div>

    <password-dialog
      @close="showModal = false"
      v-if="showModal"
      :account="param.base_info.account"
    ></password-dialog>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */

// import Store from "../../store";

import PasswordDialog from "../../../components/PasswordDialog";
import { Validator } from 'vee-validate';

export default {
  name: "account_edit",
  components: {
    PasswordDialog
  },

  watch: {
    prefCode: function(newValue, oldValue) {
      console.log("---- prefCode : newValue = " + newValue + ", oldValue = " + oldValue);

      const area = this.$store.state.weatherAreaRelationMaster.filter(
        obj => obj.prefecture_code == newValue
      );
      console.log(area);
      console.log(area[0]);
      if (oldValue != 0) {
        this.amsid = area[0].amsid;
      } else {
        if (this.param.base_info.amsid == 0) {
          this.amsid = area[0].amsid;
        }
      }
      this.fillerdWeatherArea = area;
    },

    amsid: function(newValue, oldValue) {
      console.log("---- amsid : newValue = " + newValue + ", oldValue = " + oldValue);
      const area = this.$store.state.weatherAreaRelationMaster.filter(
        obj => obj.amsid == newValue
      );

      this.param.base_info.amsid = newValue;
      this.param.base_info.lclid = area[0].lclid;
    },

    param: {
      handler: function(val) {
        if (val.base_info.account_type == 20) {
          val.base_info.parent_account = "";
          val.base_info.alert_destination_mail_address = "";
          val.base_info.function_type = 0;
        } else {
          if (val.base_info.function_type == 0) {
            val.base_info.function_type = 1;
          }
        }

        if (val.base_info.function_type != 1) {
          val.power_info.observation_machine_serial_no = "";
        }

        let area_info = [];
        for (let i = 0; i < this.clusterInfo.length; i++) {
          if (val.es_info.cluster_id == this.clusterInfo[i].cluster_id) {
            for (let j = 0; j < this.clusterInfo[i].area_info.length; j++) {
              area_info.push({ area_id:this.clusterInfo[i].area_info[j].area_id, area:this.clusterInfo[i].area_info[j].area });
            }
          }
        }
        this.areaInfo = area_info;

        if (this.currentSalesCenter != val.base_info.sales_center_id) {
          // 支店を変更した場合は営業所のリストを更新する
          const office = this.$store.state.salesOfficeMaster.filter(
            obj => obj.sales_center_id == val.base_info.sales_center_id
          );
          val.base_info.sales_office_id = "";
          this.filterSalesOffice = office;
        }

        this.currentSalesCenter = val.base_info.sales_center_id;
        this.initCustomer();
        this.initSupplier();
      },
      deep: true
    }
  },

  computed: {
    getServicePeriod: function() {
      return function(serviceStart) {
        let ret = "";
        let year = 0;
        let month = 0;
        let now = null;
        let nYear = 0;
        let nMonth = 0;
        let nTime = 0;
        let sYear = 0;
        let sMonth = 0;
        let sTime = 0;
        let start = new Date(serviceStart);

        if (serviceStart != null) {
          if (!Number.isNaN(start.getTime())) {
            sTime = parseInt(start.getTime());
            sYear = parseInt(start.getFullYear());
            sMonth = parseInt(start.getMonth());

            now = new Date();
            nTime = parseInt(now.getTime());
            nYear = parseInt(now.getFullYear());
            nMonth = parseInt(now.getMonth());

            if (nTime > sTime) {
              if (sMonth > nMonth) {
                year = (nYear - 1) - sYear;
                month = (nMonth + 12) - sMonth;
              } else {
                year = nYear - sYear;
                month = nMonth - sMonth;
              }
            }
            ret = "(　　" + year + "　年　　" + month + "　ヶ月　経過　　)";
          }
        }

        return ret;
      }
    }
  },

  data: function() {
    return {
      showModal: false,
      editMode: "new",
      fillerdWeatherArea: [],
      prefCode: 0,
      amsid: 0,
      parentList: [],
      filterSalesOffice: [],
      currentSalesCenter: "",
      clusterInfo: [],
      areaInfo: [],

      amsidOptions: [{ text: "博多", value: "point1" }],
      prefOptions: [
        { prefecture_code: "82", name: "福岡県" },
        { prefecture_code: "83", name: "大分県" },
        { prefecture_code: "84", name: "長崎県" },
        { prefecture_code: "85", name: "佐賀県" },
        { prefecture_code: "86", name: "熊本県" },
        { prefecture_code: "87", name: "宮崎県" },
        { prefecture_code: "88", name: "鹿児島県" }
      ],
      salesAlertOptions: [
        { text: "要", value: "true" },
        { text: "不要", value: "false" }
      ],
      observationMachineTypes: [
        { machine_code: "1", name: "RTR-500MBS-A (旧)" },
        { machine_code: "3", name: "RTR500BM (新)" },
        { machine_code: "2", name: "WLM-PC1" }
      ],
      referenceTime: [
        { text: "0:00", value: "00:00:00"},
        { text: "1:00", value: "01:00:00"},
        { text: "2:00", value: "02:00:00"},
        { text: "3:00", value: "03:00:00"},
        { text: "4:00", value: "04:00:00"},
        { text: "5:00", value: "05:00:00"},
        { text: "6:00", value: "06:00:00"},
        { text: "7:00", value: "07:00:00"},
        { text: "8:00", value: "08:00:00"},
        { text: "9:00", value: "09:00:00"},
        { text: "10:00", value: "10:00:00"},
        { text: "11:00", value: "11:00:00"},
        { text: "12:00", value: "12:00:00"},
        { text: "13:00", value: "13:00:00"},
        { text: "14:00", value: "14:00:00"},
        { text: "15:00", value: "15:00:00"},
        { text: "16:00", value: "16:00:00"},
        { text: "17:00", value: "17:00:00"},
        { text: "18:00", value: "18:00:00"},
        { text: "19:00", value: "19:00:00"},
        { text: "20:00", value: "20:00:00"},
        { text: "21:00", value: "21:00:00"},
        { text: "22:00", value: "22:00:00"},
        { text: "23:00", value: "23:00:00"},
      ],
      pulseCoefficient: [
        { text: "0.012", value: "0.012"},
        { text: "0.024", value: "0.024"},
        { text: "0.036", value: "0.036"},
        { text: "0.048", value: "0.048"},
        { text: "0.072", value: "0.072"},
        { text: "0.096", value: "0.096"},
        { text: "0.120", value: "0.120"},
        { text: "0.180", value: "0.180"},
        { text: "0.192", value: "0.192"},
        { text: "0.240", value: "0.240"},
      ],
      notifyTime: [
        { text: "通知しない", value: null},
        { text: "0:00", value: "00:00:00"},
        { text: "1:00", value: "01:00:00"},
        { text: "2:00", value: "02:00:00"},
        { text: "3:00", value: "03:00:00"},
        { text: "4:00", value: "04:00:00"},
        { text: "5:00", value: "05:00:00"},
        { text: "6:00", value: "06:00:00"},
        { text: "7:00", value: "07:00:00"},
        { text: "8:00", value: "08:00:00"},
        { text: "9:00", value: "09:00:00"},
        { text: "10:00", value: "10:00:00"},
        { text: "11:00", value: "11:00:00"},
        { text: "12:00", value: "12:00:00"},
        { text: "13:00", value: "13:00:00"},
        { text: "14:00", value: "14:00:00"},
        { text: "15:00", value: "15:00:00"},
        { text: "16:00", value: "16:00:00"},
        { text: "17:00", value: "17:00:00"},
        { text: "18:00", value: "18:00:00"},
        { text: "19:00", value: "19:00:00"},
        { text: "20:00", value: "20:00:00"},
        { text: "21:00", value: "21:00:00"},
        { text: "22:00", value: "22:00:00"},
        { text: "23:00", value: "23:00:00"},
        { text: "24:00", value: "23:59:59"},
      ],
      param: {
        base_info: {
          account: "",
          password: "",
          company_name: "",
          representative_mail_address: "",
          sales_center_id: "",
          sales_office_id: "",
          lclid: "",
          amsid: "",
          account_type: 10,
          supply_management: "false",
          parent_account: "",
          function_type: 1,
          deleted_flg: false,
        },
        power_info: {
          contract_power: 0,
          intercept_correction: 30,
          measure_instrument: 1,
          observation_machine_serial_no: "",
          pulse_counting: "",
          delay_time: 10,
          base_time: "06:00:00",
          air_conditioner_control: "false",
          caution_power: 0,
          limit_power: 1,
          margin: 90,
          sales_mail_address_1: "",
          sales_alert_send_flg_1: "true",
          sales_mail_address_2: "",
          sales_alert_send_flg_2: "true",
          sales_mail_address_3: "",
          sales_alert_send_flg_3: "true",
          alert_destination_mail_address: "",
          general_tool_url: "https://",
          memo: "",
        },
        es_info: {
          service_start: "",
          service_end: "",
          address: "",
          cluster_id: 0,
          area_id: 0,
          device: 0,
          memo: "",
          customer_info: [],
          supplier_info: []
        }
      },
      defaultNumber: "90",
      es_device: {
        aircon   : { bit: 0x01, bool: false },
        receiver : { bit: 0x02, bool: false },
        generator: { bit: 0x04, bool: false }
      }
    };
  },

  mounted: function() {
    console.log(`mounted= %o`, this.$route.params.id);
    // console.log(Store.state.salesCenterMaster)
    const self = this;
    this.setValidate();

    this.$axios
      .get(`/srv/api/parent_account/`, {
        withCredentials: true
      })
      .then(response => {
        if (typeof response.data == "object") {
          console.log(response.data);
          this.parentList = response.data.list;
          
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log(error);
      });

    this.$axios
      .get(`/srv/api/es/cluster_and_area/`, {
        withCredentials: true
      })
      .then(response => {
        if (typeof response.data == "object") {
          console.log(response.data);          
          if(response.data.hasOwnProperty('cluster_info')){
            this.clusterInfo = response.data.cluster_info;
            this.setAreaInfo();
          }
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log(error);
      });

    if (this.$route.params.id == "new") {
      this.editMode = "new";
      self.initCustomer();
      self.initSupplier();
    } else {
      this.editMode = "update";
      this.$axios
        .get(`/srv/api/account/${this.$route.params.id}`, {
          withCredentials: true
        })
        .then(response => {
          if (typeof response.data == "object") {
            console.log(response.data);
            response.data.power_info.air_conditioner_control = (response.data.power_info.air_conditioner_control == true ? "true" : "false");
            self.param = response.data;
            this.convDeviceBitToBool();
            self.currentSalesCenter = response.data.base_info.sales_center_id;
            if (response.data.base_info.sales_center_id != "") {
              const office = this.$store.state.salesOfficeMaster.filter(
                obj => obj.sales_center_id == response.data.base_info.sales_center_id
              );
              this.filterSalesOffice = office;
            }
            if (self.param.power_info.measure_instrument == 2 && self.param.power_info.base_time != null) {
              if (this.isTime(self.param.power_info.base_time)) {
                self.param.power_info.base_time = self.param.power_info.base_time.slice(0, 6) + '00';
              }
            }
            self.resetData();
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
      self.initCustomer();
      self.initSupplier();
    }
  },

  methods: {
    resetData: function() {
      console.log("----- resetData");
      const temp = this.param.base_info.amsid;
      console.log(temp);

      const weathers = this.$store.state.weatherAreaRelationMaster.filter(
        obj => obj.lclid == this.param.base_info.lclid
      );
      if (weathers.length > 0) {
        // this.srcPrefCode = weathers[0].prefecture_code;
        this.prefCode = weathers[0].prefecture_code;
      } else {
        // return 999;
      }
      this.amsid = temp;
      console.log("-----");

      console.log(this.amsid);
    },

    onUpdateAccount: function() {
      console.log("onUpdateAccount");
      console.log(this.param);
      this.$validator.validateAll().then(result => {
        console.log(result);

        if (result) {
          //エラーがなかった時の処理を下に記述
          this.convDeviceBoolToBit();

          this.updateBaseTime(this.param);
          if (this.editMode == "new") {
            this.createChildAccount(this.param);
          } else {
            this.updateChildAccount(this.param);
          }
        }
      });
    },

    createChildAccount: function(param) {
      const self = this;
      this.$axios
        .post(`/srv/api/account`, param, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              self.$router.go(-1);
            } else if (data.status === "parent_over") {
              console.log("parent error");
              alert("設定した親アカウントには、すでに50件以上の子アカウントが設定されています。\n別の親アカウントを設定するか、親アカウントを設定せずに登録を行ってください。");
            } else if (data.status === "duplicate") {
              alert("入力したアカウントはすでに登録されています。");
            } else {
              console.log("error");
              alert("登録できませんでした");
              // this.$store.dispatch("logout");
            }
          } else {
            console.log("error");
            alert("登録できませんでした");
            // this.$store.dispatch("logout");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateChildAccount: function(param) {
      const self = this;
      this.$axios
        .put(`/srv/api/account/${param.base_info.account}`, param, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              self.$router.go(-1);
            } else if (data.status === "parent_over") {
              console.log("parent error");
              alert("設定した親アカウントには、すでに50件以上の子アカウントが設定されています。\n別の親アカウントを設定するか、親アカウントを設定せずに登録を行ってください。");
            } else {
              console.log("error");
              alert("登録できませんでした");
              // this.$store.dispatch("logout");
            }
          } else {
            console.log("error");
            alert("登録できませんでした");
            // this.$store.dispatch("logout");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateBaseTime: function(param) {
      if (param.power_info.measure_instrument == 2 && param.power_info.observation_machine_serial_no != null && param.power_info.base_time != null) {
        const num = Number(param.power_info.observation_machine_serial_no.slice(-6));
        if (!isNaN(num)) {
          const second = num % 60;
          let baseTimeNew = param.power_info.base_time.slice(0, 6) + (('00' + second).slice(-2));
          this.param.power_info.base_time = baseTimeNew;
        }
      }
    },

    isTime: function(val) {
      const pattern = /^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/;
      if (!val.match(pattern)) {
        console.log("isTime: false");
        return false;
      }
      console.log("isTime: true");
      return true;
    },

    default1: function(){
       this.param.power_info.caution_power = null;
       this.param.power_info.limit_power = null;
       this.power_info.placeholder = "90";
    },

    setValidate: function() {
      let caution_power_validate = {
        required: () => '注意電力は必須項目です',
        numeric: () => '注意電力の入力範囲は 0 ～ 9999 です',
        min_value: () => '注意電力の入力範囲は 0 ～ 9999です',
        max_value: () => '注意電力の入力範囲は 0 ～ 9999です'
      };
      let limit_power_validate = {
        required: () => '限界電力は必須項目です',
        numeric: () => '限界電力の入力範囲は 1 ～ 9999 です',
        min_value: () => '限界電力の入力範囲は 1 ～ 9999 です',
        max_value: () => '限界電力の入力範囲は 1 ～ 9999 です'
      };
      let margin_validate = {
        required: () => '余裕率は必須項目です',
        numeric: () => '余裕率の入力範囲は 1 ～ 99 です',
        min_value: () =>  '余裕率の入力範囲は 1 ～99 です。',
        max_value: () => '余裕率の入力範囲は 1 ～ 99 です。'
      };

      let dict = { custom: {} };
      dict.custom["caution_power"] = caution_power_validate;
      dict.custom["limit_power"] = limit_power_validate;
      dict.custom["margin"] = margin_validate;
      this.$validator.localize('ja', dict);

      this.$validator.extend(
        "comp_limit_power",
        {
          params: ['caution_power'],
          getMessage: field => `限界電力は注意電力より大きい値のみ入力可能です`,
          validate (limit_power, [caution_power]) {
            if (parseInt(caution_power) >= parseInt(limit_power)) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );

      this.$validator.extend(
        "comp_end_time",
        {
          params: ['start_time'],
          getMessage: field => `開始時刻が終了時刻より大きいです`,
          validate (end_time, [start_time]) {
            let sHour = start_time.split(":")
            let eHour = end_time.split(":")
            if (parseInt((end_time.split(":"))[0]) <= parseInt(((start_time.split(":"))[0]))) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );

    },

    onTabClick: function(name, display) {
      var tabTitle;
      var tabBody;
      var children;

      tabTitle = document.getElementById('tab_header');
      children = tabTitle.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == name) {
          children[i].className = "tab active";
        } else {
          children[i].className = "tab inactive";
        }
      }

      tabBody = document.getElementById('tab_body');
      children = tabBody.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == name) {
          children[i].style.display = display;
        } else {
          children[i].style.display = "none";
        }
      }
    },

    onTabAlart: function(baseErrorCount, esErrorCount) {
      var tabTitle;
      var children;

      tabTitle = document.getElementById('tab_header');
      children = tabTitle.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].className.includes('inactive')) {
          if (((children[i].id == 'tab_base') && (baseErrorCount > 0)) ||
              ((children[i].id == 'tab_es') && (esErrorCount > 0))) {
            children[i].className = children[i].className.replace("inactive", "errors");
          }
        }
      }
    },

    convDeviceBitToBool: function () {
      this.es_device.aircon.bool    = (this.param.es_info.device & this.es_device.aircon.bit) == 0 ? false : true;
      this.es_device.receiver.bool  = (this.param.es_info.device & this.es_device.receiver.bit) == 0 ? false : true;
      this.es_device.generator.bool = (this.param.es_info.device & this.es_device.generator.bit) == 0 ? false : true;
    },

    convDeviceBoolToBit: function () {
      this.param.es_info.device  = this.es_device.aircon.bool == true ?  this.es_device.aircon.bit : 0;
      this.param.es_info.device += this.es_device.receiver.bool == true ?  this.es_device.receiver.bit : 0;
      this.param.es_info.device += this.es_device.generator.bool == true ?  this.es_device.generator.bit : 0;
    },

    initCustomer: function () {
      if (typeof this.param.es_info === 'undefined') {
        this.param.es_info = {};
      }
      if (this.param.es_info.customer_info === null) {
        this.param.es_info.customer_info = [];
      }
      if (this.param.es_info.customer_info.length < 1) {
        this.addCustomer();
      }
    },

    addCustomer: function () {
      let newItem = {
                      no: 0,
                      name: "",
                      telephone: "",
                      department: "",
                      charge: "",
                      mail_address: "",
                      binary_minor_start: "00:00:00",
                      binary_minor_end: "23:59:59",
                      binary_major_start: "00:00:00",
                      binary_major_end: "23:59:59"
                    };
      this.param.es_info.customer_info.push(newItem);
      newItem.no = this.param.es_info.customer_info.length;
    },

    initSupplier: function () {
      if (typeof this.param.es_info === 'undefined') {
        this.param.es_info = {};
      }
      if (this.param.es_info.supplier_info === null) {
        this.param.es_info.supplier_info = [];
      }
      if (this.param.es_info.supplier_info.length < 1) {
        this.addSupplier();
      }
    },

    addSupplier: function () {
      let newItem = {
                      no: 0,
                      name: "",
                      telephone: "",
                      department: "",
                      charge: "",
                      mail_address: "",
                      binary_minor_start: "00:00:00",
                      binary_minor_end: "23:59:59",
                      binary_major_start: "00:00:00",
                      binary_major_end: "23:59:59"
                    };
      this.param.es_info.supplier_info.push(newItem);
      newItem.no = this.param.es_info.supplier_info.length;
    },

    sendTestMail: function(item, name) {

      if (item.mail_address == "") {
        alert("メールアドレスが未入力です。");
        return;
      }

      this.$validator.validate(name).then(result => {
        if (result) {
          this.$axios
            .post(`/srv/api/es/send_test_mail`, item, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              const data = response.data;
              if (data.status !== undefined) {
                if (data.status === "success") {
                  alert("テストメールを送信しました。");
                } else {
                  alert("テストメールを送信に失敗しました。");
                }
              } else {
                console.log("error");
                alert("テストメールを送信に失敗しました。");
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          alert("メールアドレスは有効なメールアドレスではありません。");
        }
      });

    },

    setAreaInfo: function() {
      let area_info = [];
      for (let i = 0; i < this.clusterInfo.length; i++) {
        if (this.param.es_info.cluster_id == this.clusterInfo[i].cluster_id) {
          for (let j = 0; j < this.clusterInfo[i].area_info.length; j++) {
            area_info.push({ area_id:this.clusterInfo[i].area_info[j].area_id, area:this.clusterInfo[i].area_info[j].area });
          }
        }
      }
      this.areaInfo = area_info;
    }

  }
};
</script>
